// src/hooks/useCustomerIO.tsx
import { useCallback } from 'react';

export const useCustomerIO = () => {

  const identify = useCallback((payload: any) => {
    try {
      // Check if the global _cio object exists (from Customer.io snippet)
      // Use window._cio which is what we declared in global.d.ts
      const customerioPayload = {
        ...payload,
        ...payload?.custom,
        ...payload?.company,
        company: '',
        custom: '',
      }
      console.log('Customer.io identify call attempted:', customerioPayload);
      if (typeof window._cio !== 'undefined' && typeof window._cio.identify === 'function') {
        window._cio.identify(customerioPayload);
        console.log('Customer.io identify call attempted:', customerioPayload);
      } else {
        console.warn('Customer.io snippet (_cio or _cio.identify) not found. Skipping identify call.');
      }
    } catch (error) {
      console.error('Error calling Customer.io identify:', error);
    }
  }, []);

  const trackEvent = useCallback((eventName: string, payload?: any) => {
    try {
      // Check if the global _cio object and track method exist
      // Note: Customer.io's snippet might not always expose 'track' directly on _cio.
      // Adjust this if needed based on how you load/use the snippet.
      // Often, tracking is done via _cio.push(['track', eventName, payload]);
      if (typeof window._cio !== 'undefined') {
         // Example using push API - adjust if your snippet works differently
         // We need to assert 'any' here as '_cio.push' isn't in our simple type definition
         (window._cio as any).push(['track', eventName, payload]);
         console.log(`Customer.io track call attempted: ${eventName}`, payload);

         // If _cio.track exists directly (less common for snippet):
         /*
         if (typeof (window._cio as any).track === 'function') {
             (window._cio as any).track(eventName, payload);
             console.log(`Customer.io track call attempted: ${eventName}`, payload);
         } else {
            console.warn('Customer.io snippet (_cio.track) not found. Skipping track call.');
         }
         */
      } else {
        console.warn('Customer.io snippet (_cio) not found. Skipping track call.');
      }
    } catch (error) {
      console.error(`Error calling Customer.io track (${eventName}):`, error);
    }
  }, []);


  return {
    identify,
    trackEvent,
    // Add other Customer.io methods if needed
  };
};
